<ng-container>
    <div class="h-full flex flex-col overflow-hidden min-h-0">
        @if (creator && creator.ssCreator && creator.ssCreator.tiktokAccountId && !utlra_tiktok_account()) {

        <div class="flex-1 w-full flex flex-col gap-y-2 overflow-y-auto scrollbar-hide p-2 min-h-0">
            @if (tiktokHandleRevealed() && creator.tikTokHandle && creator.tikTokHandle !== '') {
            <div class="flex w-full shrink-0 items-center justify-center">
                <a class="btn-basic btn-primary w-full"
                    [attr.href]="'https://www.tiktok.com/@' + creator.tikTokHandle.replace('@', '')" target="_blank"
                    rel="noopener noreferrer">
                    &#64;{{ creator.tikTokHandle.replace('@', '') }}&nbsp;👉🏼
                </a>
            </div>
            }

            <!-- 2 Column Top Row -->
            @if (tiktokBasics()) {
            <div class="shrink-0 z-10 w-full grid grid-cols-2 gap-x-2 min-w-0">
                <div class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden card-container-pale">
                    <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                        <div class="flex items-center flex-row gap-x-2">
                            <div
                                class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5">
                                    <path d="M12 7v14" />
                                    <path
                                        d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
                                </svg>
                            </div>
                            <div class="">
                                <h3 class="text-sm font-semibold text-primary">Biography</h3>
                            </div>
                        </div>
                    </div>
                    <div class="px-3 py-3">
                        <div class="flex items-center flex-row gap-x-4">
                            <div
                                class="relative shrink-0 size-16 rounded-full outline-1 -outline-offset-1 outline-black/5 dark:outline-white/10">
                                <atom-ldg-img inputClass="object-cover" w="full" h="full" radius="full"
                                    [src]="imageService.getImageSource(tiktokBasics().profile_picture_url, 'gallery')"></atom-ldg-img>
                            </div>

                            <div class="flex flex-col">
                                <h3 class="text-sm text-primary">{{ tiktokBasics().bio }}</h3>
                                <p class="text-xs text-secondary truncate">{{
                                    formatService.convertIntToString(tiktokBasics().follower_count) }} Followers</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden card-container-pale">
                    <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                        <div class="flex items-center flex-row gap-x-2">
                            <div
                                class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5">
                                    <path d="M18 20a6 6 0 0 0-12 0" />
                                    <circle cx="12" cy="10" r="4" />
                                    <circle cx="12" cy="12" r="10" />
                                </svg>
                            </div>
                            <div class="">
                                @if (creator.tikTokHandle) {
                                @if (tiktokHandleRevealed()) {
                                <h3 class="text-sm font-semibold text-primary">&#64;{{ creator.tikTokHandle.replace('@',
                                    '')
                                    }}</h3>
                                } @else {
                                <h3 class="text-sm font-semibold font-mono tabular-nums tracking-wide text-secondary select-none"
                                    aria-label="TikTok handle is hidden until your subscription is active.">
                                    &#64;••••••••</h3>
                                <p class="text-xs text-secondary mt-0.5">Available with an active subscription.</p>
                                }
                                } @else {
                                <h3 class="text-sm font-semibold text-primary">Account Details</h3>
                                }

                            </div>
                        </div>
                    </div>
                    <div class="px-3 py-3 grid grid-cols-3 gap-2">
                        <div class="col-span-1">
                            <p class="text-xs font-light text-secondary">Followers</p>
                            <p class="text-xs text-primary">{{
                                formatService.convertIntToString(tiktokBasics().follower_count) }}</p>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs font-light text-secondary">Posts</p>
                            <p class="text-xs text-primary">{{
                                formatService.convertIntToString(tiktokBasics().video_count)
                                }}</p>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs font-light text-secondary">Likes</p>
                            <p class="text-xs text-primary">{{
                                formatService.convertIntToString(tiktokBasics().likes_count)
                                }}</p>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs font-light text-secondary">Avg. Views</p>
                            @if (creator.ssCreator && creator.ssCreator.tiktokAverages &&
                            creator.ssCreator.tiktokAverages.averageViews) {
                            <p class="text-xs text-primary">{{
                                formatService.convertIntToString(creator.ssCreator.tiktokAverages.averageViews) }}</p>
                            } @else {
                            <p class="text-xs text-primary">-</p>
                            }
                        </div>

                        <div class="col-span-1">
                            <p class="text-xs font-light text-secondary">Avg. Likes</p>
                            @if (creator.ssCreator && creator.ssCreator.tiktokAverages &&
                            creator.ssCreator.tiktokAverages.averageLikes) {
                            <p class="text-xs text-primary">{{
                                formatService.convertIntToString(creator.ssCreator.tiktokAverages.averageLikes) }}</p>
                            } @else {
                            <p class="text-xs text-primary">-</p>
                            }
                        </div>

                        <div class="col-span-1">
                            <p class="text-xs font-light text-secondary">Avg. Engagement</p>
                            @if (creator.ssCreator && creator.ssCreator.tiktokAverages &&
                            creator.ssCreator.tiktokAverages.averageEngagementRate) {
                            <p class="text-xs text-primary">{{
                                formatService.convertIntToString(creator.ssCreator.tiktokAverages.averageEngagementRate)
                                |
                                number:'1.1-2' }}%</p>
                            } @else {
                            <p class="text-xs text-primary">-</p>
                            }
                        </div>

                    </div>
                </div>
            </div>
            }
            <!-- 2 Column Top Row END -->

            <!-- Admin Row -->
            <div *appHasRole="[4,6]" class="shrink-0 z-10 w-full">
                <div class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden card-container-pale">
                    <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                        <div class="flex items-center flex-row gap-x-2">
                            <div
                                class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5">
                                    <path
                                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                                    <path d="M6.376 18.91a6 6 0 0 1 11.249.003" />
                                    <circle cx="12" cy="11" r="4" />
                                </svg>
                            </div>
                            <div class="">
                                <h3 class="text-sm font-semibold text-primary">TikTok Admin</h3>
                            </div>
                        </div>
                    </div>
                    @if (!accountOwnershipChanged() && tiktokBasics()) {
                    <div class="px-3 py-3 grid grid-cols-5 gap-2">
                        <div class="col-span-1">
                            <p class="text-xs font-light text-secondary">Source</p>
                            <p class="text-xs text-primary">{{ creator.ssCreator.tiktokSource }}</p>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs font-light text-secondary">Created</p>
                            <p class="text-xs text-primary">{{ tiktokBasics()?.createdDate | date:'dd MMM yyyy' }}
                            </p>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs font-light text-secondary">Updated</p>
                            <p class="text-xs" [class]="getUpdatedDateColour(tiktokBasics()!.updatedDate)">{{
                                formatService.getTimeSinceUpdated(tiktokBasics()!.updatedDate) }}
                            </p>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs font-light text-secondary">Account ID</p>
                            <p class="text-xs text-primary">{{ tiktokBasics()?.tiktok_account_id }}</p>
                        </div>
                        <div class="col-span-1 flex items-center justify-end">
                            @if (refreshTiktokAccountLoading()) {
                            <span
                                class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
                                <svg aria-hidden="true"
                                    class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor" />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill" />
                                </svg>

                                Orchestrating...
                            </span>
                            } @else if (accountRefreshed()) {
                            <span
                                class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-500/20">Refesh
                                Request Sent!</span>
                            }
                            @else {
                            @if (allowedToRefreshInstagramAccount(tiktokBasics()!.updatedDate)) {
                            <button (click)="refreshTiktokAccount()" type="button"
                                class="inline-flex items-center gap-x-1.5 btn-shout btn-shout-xs btn-shout-primary">
                                Refresh Account
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="-mr-0.5 size-5">
                                    <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                                    <path d="M3 3v5h5" />
                                    <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                                    <path d="M16 16h5v5" />
                                </svg>
                            </button>
                            } @else {
                            <span
                                class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-500/20">Up
                                to date</span>
                            }
                            }
                        </div>
                    </div>
                    } @else if (accountOwnershipChanged()) {
                    <div class="px-3 pt-3">
                        <div
                            class="rounded-md bg-yellow-50 p-4 dark:bg-yellow-500/10 dark:outline dark:outline-yellow-500/15">
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="size-5 text-yellow-400 dark:text-yellow-300">
                                        <path
                                            d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <h3 class="text-sm font-medium text-yellow-800 dark:text-yellow-100">Account
                                        Ownership
                                        Changed - @{{ creator.tikTokHandle.replace('@', '') }}</h3>
                                    <div class="mt-2 text-sm text-yellow-700 dark:text-yellow-100/80">
                                        <p>A different creator account has verified thier ownership of this accout using
                                            an
                                            authentic TikTok login.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <!-- Admin Row - END -->

            <!-- 1 Column Audience Row -->
            <!-- <div
            class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-gradient-to-b from-white via-zinc-50 to-zinc-100 border border-gray-200">
            <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                <div class="flex items-center flex-row gap-x-2">
                    <div class="shrink-0 size-8 rounded-full bg-gray-50 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="M3 3v16a2 2 0 0 0 2 2h16" />
                            <path d="M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7" />
                        </svg>
                    </div>
                    <div class="">
                        <h3 class="text-sm font-semibold text-primary">Account Statistics</h3>
                    </div>
                </div>
                <div class="flex shrink-0 gap-x-2 text-transparent">
                    RHS
                </div>
            </div>
            <div class="px-3 py-3 grid grid-cols-3 gap-2">
                <div class="col-span-1 bg-white rounded-lg p-2 border border-gray-200">
                </div>
                <div class="col-span-1 bg-white rounded-lg p-2 border border-gray-200">
                </div>
                <div class="col-span-1 bg-white rounded-lg p-2 border border-gray-200">
                </div>
            </div>
        </div> -->
            <!-- 1 Column Audience Row END -->

            <!-- 1 Column TikTok Posts Row -->
            <div
                class="flex-shrink-0 divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden card-container-pale">
                <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                    <div class="flex items-center flex-row gap-x-2">
                        <div
                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5">
                                <path d="M2 7v10" />
                                <path d="M6 5v14" />
                                <rect width="12" height="18" x="10" y="3" rx="2" />
                            </svg>
                        </div>
                        <div class="">
                            <h3 class="text-sm font-semibold text-primary">TikTok Posts</h3>
                        </div>
                    </div>
                </div>
                <div class="px-3 py-3 w-full shrink-0 overflow-hidden">


                    @if (tiktokPosts() && tiktokPosts()!.length > 0) {
                    <div class="flex flex-col gap-4">
                        <ul role="list" class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-2 gap-y-4">
                            @for (post of tiktokPosts(); track post.id) {
                            <li
                                class="relative w-full min-w-0 bg-white dark:bg-zinc-900 rounded-lg p-2 border border-gray-200 dark:border-zinc-800 flex flex-col self-start">
                                <div class="relative overflow-hidden rounded-lg">
                                    @if (post.tiktokCarouselFile) {
                                    <atom-media-viewer-simpler
                                        class="w-full group overflow-hidden rounded-lg bg-gray-100 dark:bg-zinc-800 focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary dark:focus-within:outline-primary"
                                        [src]="getCoverImage(post)"
                                        [inputClass]="'w-full pointer-events-none aspect-9/16 object-cover group-hover:opacity-75 rounded-t-lg'"
                                        [post]="post" w="full"></atom-media-viewer-simpler>
                                    } @else if (superSocialVideoUrl(post) || getUsableCoverUrl(post)) {
                                    <atom-video-thumbnail [videoUrl]="superSocialVideoUrl(post)"
                                        [thumbnailURL]="getUsableCoverUrl(post)"
                                        [videoFormat]="0"></atom-video-thumbnail>
                                    } @else {
                                    <img src="/assets/images/placeholder-video.png" alt="Video thumbnail unavailable"
                                        class="aspect-9/16 w-full h-full object-cover rounded-lg" />
                                    }
                                    @if (superSocialEmbedVideoId(post)) {
                                    <button type="button"
                                        class="absolute inset-0 flex items-center justify-center rounded-lg bg-black/20 hover:bg-black/40 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                                        (click)="openSuperSocialTiktokEmbed(post)" aria-label="Play TikTok video">
                                        <span
                                            class="flex size-12 items-center justify-center rounded-full bg-white/90 text-accent shadow-md"
                                            aria-hidden="true">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                fill="currentColor" class="size-6">
                                                <path fill-rule="evenodd"
                                                    d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                        </span>
                                    </button>
                                    }
                                </div>

                                <p class="text-xs text-secondary line-clamp-2 h-[2lh] mt-2">{{ post.title }}</p>
                            </li>
                            }
                        </ul>
                    </div>
                    } @else if (tiktokPosts() && tiktokPosts()!.length === 0) {
                    <div class="flex flex-col gap-4 p-4 w-full items-center justify-center">
                        <div class="text-center">
                            <img class="size-10 mx-auto" src="../../../../../assets/social-icon/tik-tok-transparent.svg"
                                alt="TikTok">
                            <h3 class="mt-2 text-sm font-semibold text-primary">No TikTok posts found</h3>
                            <p class="mt-1 text-sm text-secondary">TikTok posts will appear here once they are
                                available.
                            </p>
                        </div>
                    </div>
                    } @else {
                    <div class="flex flex-col gap-4 p-4 w-full items-center justify-center">
                        <atom-loading-inline [title]="'TikTok Posts'" [message]="'Loading... '"></atom-loading-inline>
                    </div>
                    }
                </div>
            </div>
            <!-- 1 Column TikTok Posts Row END -->


        </div>


        } @else if (creator && ultra_social_tiktok) {
        @if (utlra_tiktok_account()) {
        <div class="flex-1 w-full flex flex-col gap-y-2 overflow-y-auto scrollbar-hide p-1 min-h-0">
            <div class="w-full grid grid-cols-3 gap-x-2">
                <!-- Bio Column -->
                <div
                    class="col-span-1 p-2 overflow-hidden rounded-lg bg-white shadow-sm dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10 flex flex-row gap-x-2 ">
                    <div class="shrink-0">
                        <div
                            class="relative shrink-0 size-16 rounded-full outline-1 -outline-offset-1 outline-black/5 dark:outline-white/10">
                            <atom-ldg-img inputClass="object-cover" w="full" h="full" radius="full"
                                [src]="imageService.getImageSource(utlra_tiktok_account()!.avatarUrl, 'gallery')"></atom-ldg-img>
                        </div>
                    </div>
                    <div class="flex-1">
                        @if (creator.tikTokHandle) {
                        @if (tiktokHandleRevealed()) {
                        <h3 class="text-sm font-semibold text-primary">&#64;{{ creator.tikTokHandle.replace('@',
                            '')
                            }}</h3>
                        } @else {
                        <h3 class="text-sm font-semibold font-mono tabular-nums tracking-wide text-secondary select-none"
                            aria-label="TikTok handle is hidden until your subscription is active.">
                            &#64;••••••••</h3>
                        <p class="text-xs text-secondary mt-0.5">Available with an active subscription.</p>
                        }
                        } @else {
                        <h3 class="text-sm font-semibold text-primary">Account Details</h3>
                        }
                        <p class="mt-1 text-gray-500 dark:text-gray-400">{{ utlra_tiktok_account()!.bio }}</p>
                    </div>
                </div>
                <!-- Bio Column - END -->

                <!-- Stats Column -->
                <div
                    class="col-span-2 overflow-hidden rounded-lg bg-white shadow-sm dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10 flex flex-row gap-x-2 ">
                    <div class="bg-white dark:bg-gray-900 w-full">
                        <div
                            class="grid grid-cols-1 gap-px bg-gray-900/5 sm:grid-cols-2 lg:grid-cols-3 dark:bg-white/10">
                            <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                                <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Followers
                                </p>
                                <p class="flex items-baseline gap-x-2">
                                    <span class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                        formatService.convertIntToString(utlra_tiktok_account()!.followerCount)
                                        }}</span>
                                </p>
                            </div>
                            <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                                <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Posts</p>
                                <p class="flex items-baseline gap-x-2">
                                    <span class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                        formatService.convertIntToString(utlra_tiktok_account()!.postCount) }}</span>
                                </p>
                            </div>
                            <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                                <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Likes
                                </p>
                                <p class="flex items-baseline gap-x-2">
                                    <span class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                        formatService.convertIntToString(utlra_tiktok_account()!.likesCount) }}</span>
                                </p>
                            </div>
                            <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                                <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Avg. Views</p>
                                <p class="flex items-baseline gap-x-2">
                                    <span
                                        class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">-</span>
                                </p>
                            </div>
                            <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                                <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Avg. Likes</p>
                                <p class="flex items-baseline gap-x-2">
                                    @if (utlra_tiktok_account()!.likesCount && utlra_tiktok_account()!.postCount) {
                                    <span class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                        formatService.convertIntToString(utlra_tiktok_account()!.likesCount /
                                        utlra_tiktok_account()!.postCount) }}</span>
                                    } @else {
                                    <span
                                        class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">-</span>
                                    }
                                </p>
                            </div>
                            <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                                <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Avg. Engagement</p>
                                <p class="flex items-baseline gap-x-2">
                                    <span
                                        class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">-</span>
                                </p>
                            </div>
                        </div>
                    </div>


                </div>
                <!-- Stats Column - END -->
            </div>

            <!-- Ultra Social Posts -->
            @if (utlra_tiktok_posts() && utlra_tiktok_posts()!.length > 0) {
            <div class="flex flex-col gap-4">
                <ul role="list" class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-2 gap-y-4">
                    @for (post of utlra_tiktok_posts(); track post.id) {
                    <li
                        class="relative w-full min-w-0 bg-white dark:bg-zinc-900 rounded-lg p-2 border border-gray-200 dark:border-zinc-800 flex flex-col self-start">
                        @if (post.assetMediaUrl) {
                        <mgc-portfolio-inline-video [video]="assembledVideoObject(post)"></mgc-portfolio-inline-video>
                        } @else {
                        <div class="relative overflow-hidden rounded-lg">
                            @if (hasUltraVideoPreview(post)) {
                            <atom-video-thumbnail [videoUrl]="''" [thumbnailURL]="ultraThumbnailUrl(post)"
                                [cdnKey]="ultraThumbnailCdnKey(post)" [videoFormat]="0"></atom-video-thumbnail>
                            } @else if (ultraPostImageSrc(post)) {
                            <img [src]="ultraPostImageSrc(post)" alt="TikTok post image"
                                class="aspect-9/16 w-full h-full object-cover rounded-lg" />
                            } @else {
                            <img src="/assets/images/placeholder-video.png" alt="Video thumbnail unavailable"
                                class="aspect-9/16 w-full h-full object-cover rounded-lg" />
                            }
                            @if (ultraEmbedVideoId(post)) {
                            <button type="button"
                                class="absolute inset-0 flex items-center justify-center rounded-lg bg-black/20 hover:bg-black/40 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                                (click)="openUltraTiktokEmbed(post)" aria-label="Play TikTok video">
                                <span
                                    class="flex size-12 items-center justify-center rounded-full bg-white/90 text-accent shadow-md"
                                    aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        class="size-6">
                                        <path fill-rule="evenodd"
                                            d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </span>
                            </button>
                            }
                        </div>
                        }

                        @if (post.viewCount != null || post.likeCount != null) {
                        <p class="text-xs text-secondary mt-2">
                            @if (post.viewCount != null) {
                            {{ formatService.convertIntToString(post.viewCount) }} views
                            }
                            @if (post.likeCount != null) {
                            · {{ formatService.convertIntToString(post.likeCount) }} likes
                            }
                        </p>
                        }

                        <p class="text-xs text-secondary line-clamp-2 h-[2lh] mt-1">{{ post.caption }}</p>
                    </li>
                    }
                </ul>
            </div>
            } @else if (utlra_tiktok_posts() && utlra_tiktok_posts()!.length === 0) {
            <div class="flex flex-col gap-4 p-4 w-full items-center justify-center">
                <div class="text-center">
                    <img class="size-10 mx-auto" src="../../../../../assets/social-icon/tik-tok-transparent.svg"
                        alt="TikTok">
                    <h3 class="mt-2 text-sm font-semibold text-primary">No TikTok posts found</h3>
                    <p class="mt-1 text-sm text-secondary">TikTok posts will appear here once they are
                        available.
                    </p>
                </div>
            </div>
            } @else {
            <div class="flex flex-col gap-4 p-4 w-full items-center justify-center">
                <atom-loading-inline [title]="'TikTok Posts'" [message]="'Loading... '"></atom-loading-inline>
            </div>
            }
            <!-- Ultra Social Posts - END -->
        </div>
        } @else {
        <div class="flex-1 w-full flex flex-col p-2 min-h-0 items-center justify-center">
            <atom-loading-inline [title]="'TikTok Posts'" [message]="'Loading... '"></atom-loading-inline>
        </div>
        }

        } @else if (creator.tikTokHandle) {
        <div class="flex-1 w-full flex flex-col items-center justify-center gap-4 p-6 min-h-0">
            <div class="w-full max-w-md rounded-xl border border-border bg-card p-5">
                <div class="flex items-center gap-3">
                    <img class="size-10 shrink-0 object-contain"
                        src="../../../../../assets/social-icon/tik-tok-transparent.svg" alt="">
                    <div class="min-w-0 flex-1">
                        <p class="m-0 truncate text-sm font-bold text-primary">
                            &#64;{{ creator.tikTokHandle.replace('@', '') }}
                        </p>
                        <p class="m-0 text-xs text-secondary">TikTok</p>
                    </div>
                    <p class="m-0 shrink-0 text-lg font-extrabold text-primary">
                        {{ creator.tikTokFollowers ? formatService.convertIntToString(creator.tikTokFollowers) : '—' }}
                    </p>
                </div>
                <p class="m-0 mt-4 text-sm text-secondary">
                    This handle is on the creator profile, but TikTok isn’t linked to Super Social or Ultra yet — posts
                    and analytics will show here once that connection is live.
                </p>
                <a class="btn-shout btn-shout-sm btn-shout-secondary mt-4 inline-flex"
                    [attr.href]="'https://www.tiktok.com/@' + creator.tikTokHandle.replace('@', '')" target="_blank"
                    rel="noopener noreferrer">
                    Open TikTok
                </a>
            </div>
        </div>
        } @else if (creator && creator.ssCreator && !creator.ssCreator.tiktokAccountId) {
        <div class="flex-1 w-full flex flex-col p-2 min-h-0 items-center justify-center">
            <div class="text-center">
                <img class="size-10 mx-auto" src="../../../../../assets/social-icon/tik-tok-transparent.svg"
                    alt="TikTok">
                <h3 class="mt-2 text-sm font-semibold text-primary">TikTok account not connected</h3>
                <p class="mt-1 text-sm text-secondary">When the creator connects their TikTok account, their account
                    details will appear here.
                </p>
            </div>
        </div>
        } @else if (creator && !creator.ssCreator) {
        <div class="flex-1 w-full flex flex-col p-2 min-h-0 items-center justify-center">
            <div class="text-center">
                <img class="size-10 mx-auto" src="../../../../../assets/social-icon/tik-tok-transparent.svg"
                    alt="TikTok">
                <h3 class="mt-2 text-sm font-semibold text-primary">No TikTok account connected</h3>
                <p class="mt-1 text-sm text-secondary">When the creator connects their TikTok account, their account
                    details will appear here.
                </p>
            </div>
        </div>
        } @else {
        <div class="flex-1 w-full flex flex-col p-2 min-h-0 items-center justify-center">
            <div class="text-center">
                <img class="size-10 mx-auto" src="../../../../../assets/social-icon/tik-tok-transparent.svg"
                    alt="TikTok">
                <h3 class="mt-2 text-sm font-semibold text-primary">Something else...</h3>
                <p class="mt-1 text-sm text-secondary">When the creator connects their TikTok account, their account
                    details will appear here.
                </p>
            </div>
        </div>
        }
    </div>

    <app-dialog [open]="tiktokEmbedOpen()" (closed)="closeTiktokEmbed()">
        <div dialog-header>
            <h2 class="text-lg font-semibold text-primary">TikTok video</h2>
        </div>
        <div dialog-body class="flex flex-col items-center gap-3">
            @if (tiktokEmbedSrc()) {
            <iframe [src]="tiktokEmbedSrc()" title="TikTok video player"
                class="aspect-9/16 w-full max-w-sm rounded-lg bg-black"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                allowfullscreen></iframe>
            }
            @if (tiktokWatchUrl()) {
            <a class="text-sm font-medium text-accent hover:underline" [href]="tiktokWatchUrl()" target="_blank"
                rel="noopener noreferrer">Open on TikTok</a>
            }
        </div>
    </app-dialog>
</ng-container>